import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forEach } from 'lodash';
import { Observable, empty } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { IMacro, ProductTemplate, BaseResponse } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class V6macroService {

  constructor(private httpClient: HttpClient) { }

  macroList: any[] = [];

  getMacros() {
    return this.macroList;
  }
  //#region   Api endPoints
  public getAll(): Observable<Array<IMacro>> {
    const endPoint = `${ConfigService.APIs.endPoints.MACRO.GET_V6MACROS}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((macros) => { this.macroList = macros })
      );
  }
  //#endregion

  macroFilterChangeHandler(value: string) {
    return this.getMacros().filter((s: IMacro) => (s.name ? s.name : '').toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }
  runMacros(eventType: string, macros: any[], productModel) {
    this.model = productModel;
    let relevantMacros = [];
    this.attachMacroHelperFunctions(productModel);
    switch (eventType) {
      case 'onChange':
        relevantMacros = macros.filter(m => m.type === 'Update');
        relevantMacros.push(...macros.filter(m => m.type === 'Query'));
        relevantMacros.push(...macros.filter(m => m.type === 'ValidateOnChange'));
        break;
      case 'pageLoad':
        relevantMacros = macros.filter(m => m.type === 'RepositionRules');
        relevantMacros.push(...macros.filter(m => m.type === 'Update'));
        relevantMacros.push(...macros.filter(m => m.type === 'Query'));
        break;
      case 'validate':
        relevantMacros = macros.filter(m => m.type === 'Validate');
        break;
      case 'confirm':
        relevantMacros = macros;//.filter(m => m.type === 'Validate');
        break;
      case 'reposition':
        relevantMacros = macros.filter(m => m.type === 'RepositionRules');
        break;
      case 'computeName':
        relevantMacros = macros;
        break;
      default: break;
    }
    if (relevantMacros) {
      console.log('macro start');
      relevantMacros.forEach((m, index) => {
        try {
          if (m.expression && m.expression.length > 0) {
            const f = new Function(m.expression);
            f.apply(this);
          }
          else {
            throw ('no body in macro');
          }
        }
        catch (ex) { console.log(m.name + ex); }
      })

      console.log('macro end');
    }

  }
  //#region macro test
  model: any;

  //#endregion

  //#region helper function
  attachMacroHelperFunctions(product: ProductTemplate) {
    if (!product["findResourceFrameAttr"]) {
      product["findResourceFrameAttr"] = this.findResourceFrameAttr;
      product["findProductAttr"] = this.findProductAttr;
      product["findNestedFrameAttr"] = this.findNestedFrameAttr;
      product["findAttrOption"] = this.findAttrOption;
      product["findNestedFrameAttrByV6RefCode"] = this.findNestedFrameAttrByV6RefCode;
    }
  }
  findResourceFrameAttr = function (attrName) {
    let attr = this.resourceFrame.attributeFilters.find(x => x.publishedName === attrName);//v6ReferenceCode
    if (!attr) { attr = this.resourceFrame.attributeFilters.find(x => x.v6ReferenceCode === attrName) };
    if (!attr) {
      console.log('findResourceFrameAttr--not found', attrName);
    }
    return attr

  }
  findProductAttr = function (attrName) {
    let attr = this.productAttributes.find(x => x.publishedName === attrName);
    if (!attr) { attr = this.productAttributes.find(x => x.v6ReferenceCode === attrName) };
    if (!attr) {
      console.log('findProductAttr--not found', attrName);
    }
    return attr
  }
  findProductAttrByV6RefCode = function (attrV6RefCode: string) {
    let attr = this.productAttributes.find(x => x.v6ReferenceCode === attrV6RefCode);
    if (!attr) {
      console.log('findProductAttrByV6RefCode--not found', attrV6RefCode);
    }
    return attr
  }

  findNestedFrameAttrByV6RefCode = function (attrV6RefCode, frameIndex: number) {
    let attr = this.nestedFrames[frameIndex].attributeFilters.find(x => x.v6ReferenceCode === attrV6RefCode);
    if (!attr) {
      console.log('findNestedFrameAttrByV6RefCode--not found', attrV6RefCode);
    }
    return attr
  }

  findNestedFrameAttr = function (attrName, frameIndex: number) {
    let attr = this.nestedFrames[frameIndex].attributeFilters.find(x => x.publishedName === attrName);
    if (!attr) { attr = this.nestedFrames[frameIndex].attributeFilters.find(x => x.v6ReferenceCode === attrName); }
    if (!attr) {
      console.log('findNestedFrameAttr--not found', attrName);
    }
    return attr
  }
  findAttrOption = function (optionValue, attr: any) {
    let opt = attr.options.find(x => x.value === optionValue);
    if (!opt) {
      console.log('findAttrOption--not found', attr.publishedName);
    }
    return opt;
  }
  //#endregion



  c7() {
    ///Hide Screen Mesh for GVs on BP2
    let Displayscreenmesh = false;
    const screenAtt = this.model.findResourceFrameAttr("Screens");
    if (screenAtt) {
      if (screenAtt.value === "True") { Displayscreenmesh = true; }
    }
    const screenmeshAtt = this.model.findResourceFrameAttr("ScreenMesh");
    if (screenmeshAtt) {
      if (Displayscreenmesh) { screenmeshAtt.show = true; }
      else { screenmeshAtt.show = false; }
    }

    //var Displayscreenmesh = false; var screenAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Screens"_END_; if (screenAtt != null && screenAtt.$VALUE$ == "True") { Displayscreenmesh = true; } var screenmeshAtt = _MODEL_.Frames[0]._FIND_ATTRC_"ScreenMesh"_END_; if (Displayscreenmesh == true) { screenmeshAtt.$SHOWDETAILS()$; } else { screenmeshAtt.$HIDE()$; } return _MODEL_; 

    ///Hide ScreenType for GVs on BP2
    const ScreenType = this.model.findResourceFrameAttr("ScreenType"); if (ScreenType) ScreenType.show = false;
    //_MODEL_.Frames[0]._FIND_ATTRC_"ScreenType"_END_.$HIDE()$;  return _MODEL_;


    ///Toggle AC Handle per Unit Attribute

    let DisplayAcHandlePerUnit = false;
    const lockAtt = this.model.findResourceFrameAttr("Locking");
    if (lockAtt) {
      if (lockAtt.value === "03") { DisplayAcHandlePerUnit = true; }
    }
    const acHandlePerUnitAtt = this.model.findResourceFrameAttr("AC Handle per Unit");
    if (acHandlePerUnitAtt) {
      if (DisplayAcHandlePerUnit) { acHandlePerUnitAtt.show = true; }
      else { acHandlePerUnitAtt.show = false; }
    }

    //AC/CL Handle per Unit

    const acCLHandlePerUnitAtt = this.model.findResourceFrameAttr("AC/CL Handle per Unit");
    if (acCLHandlePerUnitAtt) {
      if (DisplayAcHandlePerUnit) { acCLHandlePerUnitAtt.show = true; }
      else { acCLHandlePerUnitAtt.show = false; }
    }

    //var DisplayAcHandlePerUnit = false;  var lockAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Locking"_END_;  if (lockAtt != null && lockAtt.$VALUE$ == "03") {      DisplayAcHandlePerUnit = true; }  var acHandlePerUnitAtt = _MODEL_.Frames[0]._FIND_ATTRC_"AC Handle per Unit"_END_;  if (DisplayAcHandlePerUnit == true) {   acHandlePerUnitAtt.$SHOWDETAILS()$; } else {   acHandlePerUnitAtt.$HIDE()$; }  return _MODEL_;    

    ///Hide Limit Stop Info for SEF, 1600, UT on BP2

    const LimitStopInfo = this.model.findResourceFrameAttr("Limit Stop Info");
    if (LimitStopInfo) { LimitStopInfo.show = false; }


    ///Reorder Vent Dimension Type-- not done yet

    const widthAtt = this.model.findNestedFrameAttr("WidthDimension", 0);
    //reorder
    const ventdimensionAtt = this.model.findNestedFrameAttr("Vent Dimension Type", 0);
    if (ventdimensionAtt) {
      const indexOfventdimensionAtt = this.model.nestedFrames[0].attributeFilters.indexOf(ventdimensionAtt);
      if (indexOfventdimensionAtt > -1) {
        this.model.nestedFrames[0].attributeFilters.splice(indexOfventdimensionAtt, 1);
      }

    }

    if (ventdimensionAtt && widthAtt) {

      const indexOfwidthAtt = this.model.nestedFrames[0].attributeFilters.indexOf(widthAtt);
      if (indexOfwidthAtt > -1) {
        this.model.nestedFrames[0].attributeFilters.splice(indexOfwidthAtt, 0, ventdimensionAtt);
      } else {
        this.model.nestedFrames[0].attributeFilters.splice(0, 0, ventdimensionAtt);
      }

    }




    ////////point of reference
    //////var widthAtt = _MODEL_.Frames[0]._FIND_ATTRC_"WidthDimension"_END_;

    ////////reorder
    //////var ventdimensionAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Vent Dimension Type"_END_;

    //////var indexOfventdimensionAtt = _MODEL_.Frames[0].Attributes.IndexOf(ventdimensionAtt);
    //////_MODEL_.Frames[0].Attributes.RemoveAt(indexOfventdimensionAtt);
    //////var indexOfwidthAtt = _MODEL_.Frames[0].Attributes.IndexOf(widthAtt);
    //////_MODEL_.Frames[0].Attributes.Insert(indexOfwidthAtt - 1, ventdimensionAtt);

    //////return _MODEL_;








    ///Hide Pocket Filler--done

    const frameSystemAtt = this.model.findResourceFrameAttr("SetInFrame");
    const pocketfillerAtt = this.model.findResourceFrameAttr("PocketFillers");
    if (pocketfillerAtt && frameSystemAtt) {
      if (frameSystemAtt && frameSystemAtt.value === "FXF") {
        this.model.findAttrOption("CW", pocketfillerAtt).show = false;
        this.model.findAttrOption("WW1", pocketfillerAtt).show = false;
        this.model.findAttrOption("WW2", pocketfillerAtt).show = false;
        this.model.findAttrOption("00", pocketfillerAtt).show = true;
        this.model.findAttrOption("SF", pocketfillerAtt).show = true;
      } else if (frameSystemAtt && frameSystemAtt.value === "CWF") {
        this.model.findAttrOption("CW", pocketfillerAtt).show = true;
        this.model.findAttrOption("WW1", pocketfillerAtt).show = true;
        this.model.findAttrOption("WW2", pocketfillerAtt).show = true;
        this.model.findAttrOption("00", pocketfillerAtt).show = true;
        this.model.findAttrOption("SF", pocketfillerAtt).show = false;
      } else {
        this.model.findAttrOption("CW", pocketfillerAtt).show = true;
        this.model.findAttrOption("WW1", pocketfillerAtt).show = true;
        this.model.findAttrOption("WW2", pocketfillerAtt).show = true;
        this.model.findAttrOption("00", pocketfillerAtt).show = true;
        this.model.findAttrOption("SF", pocketfillerAtt).show = true;
      }
    }


    ///Toggle Limit Stop Opening for UT on BP2 (TEST2)--done

    let DisplayLimitStopOpening = false;
    const limitStopAtt = this.model.findResourceFrameAttr("LimitStop");
    if (limitStopAtt) {
      if (limitStopAtt.value === "True") { DisplayLimitStopOpening = true; }
    }
    let limitStopOpeningAtt = this.model.findResourceFrameAttr("Limit Opening In inches to");
    if (limitStopOpeningAtt) {
      if (DisplayLimitStopOpening) { limitStopOpeningAtt.show = true; }
      else { limitStopOpeningAtt.show = false; }
    }





  }
  jh() {
    ////Toggle Limit Stop Opening for SEFCO

    //var DisplayLimitStopOpening = false;

    //var limitStopAtt = _MODEL_.Frames[0]._FIND_ATTRC_"LimitStop"_END_;

    //if (limitStopAtt != null && limitStopAtt.$VALUE$ == "03") {
    //  DisplayLimitStopOpening = true;
    //}

    //var limitStopOpeningAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Limit Stop Opening"_END_;

    //if (DisplayLimitStopOpening == true) {
    //  limitStopOpeningAtt.$SHOWDETAILS()$;

    //}
    //else {
    //  limitStopOpeningAtt.$HIDE()$;
    //}

    //return _MODEL_;

    let DisplayLimitStopOpening = false;
    const limitStopAtt = this.model.findResourceFrameAttr("LimitStop");
    if (limitStopAtt != null && limitStopAtt.value == "03") {
      DisplayLimitStopOpening = true;
    }
    let limitStopOpeningAtt = this.model.findResourceFrameAttr("Limit Stop Opening");
    if (DisplayLimitStopOpening == true) {
      limitStopOpeningAtt.show = true;
    }
    else {
      limitStopOpeningAtt.show = false;
    }

  }

  //////kj() {
  //////  var messages = new List<string>();
  //////  for (int i = 0; i < _MODEL_.$DOORS$.Count; i++)
  //////  {
  //////    var door = _MODEL_.$DOORS$[i];
  //////    var closerPrepRequired = false;
  //////    var hingeAttribute = door._FIND_ATTR_"Hinge"_END_;
  //////    var closerAttribute = door._FIND_ATTR_"Closer"_END_;
  //////    if (hingeAttribute != null && closerAttribute != null)
  //////    {
  //////      string hingeValue = hingeAttribute.$VALUE$;
  //////      string closerValue = closerAttribute.$VALUE$; if (hingeValue == "00")
  //////      {
  //////        if (closerValue == "20" || closerValue == "03" || closerValue == "04" ||
  //////          closerValue == "06") { closerPrepRequired = true; }
  //////      }
  //////    } if (closerPrepRequired)
  //////    {
  //////      var Spec_COC_Dop = door._FIND_ATTR_"Spec_COC_Dop"_END_;
  //////      if (Spec_COC_Dop != null) {
  //////        var Spec_COC_Dop_Value = Spec_COC_Dop.$VALUE$;
  //////        if (Spec_COC_Dop_Value == "00" || Spec_COC_Dop_Value == "01")
  //////        {
  //////          messages.Add(String.Format("Door {0}: Hinge Type for Concealed Closer Prep selection is required",
  //////            i + 1)); messages.Add(String.Format("[Door{0}.Hinge]", i + 1));
  //////          messages.Add(String.Format("[Door{0}.Closer]", i + 1));
  //////          messages.Add(String.Format("[Door{0}.Spec_COC_Dop]", i + 1));
  //////        }
  //////      }
  //////    }
  //////  } return messages;
  //////  // CPN pull only available in 14,29, and 40 finish. so let the customer know that!! var errors = new List<string>(); for (int i = 0; i < _MODEL_.$DOORS$.Count; i++) {     var door = _MODEL_.$DOORS$[i];     var PanicPull = door._FIND_ATTRC_"PncPull"_END_;     if (PanicPull != null)      {          var PPullFin = _MODEL_._FIND_ATTRP_"Push/Pull Finish"_END_.$VALUE$;         if (PanicPull.$VALUE$ == "15" && PPullFin != "[COL:K:14 (14)]" && PPullFin != "[COL:K:29 (29)]" && PPullFin != "[COL:K:40 (40)]" )         {             errors.Add(String.Format("Door {0}: CPN Pull Handles are only available in 14, 29, and 40 Finish, Please reset your Push/Pull Finish choice, or choose a different Pull handle [\"PncPull\"]", i + 1));         //    errors.Add(String.Format("Door {0}: CPN Pull Handles are only available in 14, 29, and 40 Finish, Please reset your Push/Pull Finish choice, or choose a different Pull handle", i + 1));                     }     } } return errors; 
  //////  foreach(var door in _MODEL_.$DOORS$) {
  //////    var isPanic = false; var lockAttribute = door._FIND_ATTR_"Lock"_END_;
  //////    if (lockAttribute != null) {
  //////      string lockValue = lockAttribute.$VALUE$;
  //////      if (lockValue == "15" || lockValue == "20" || lockValue == "31"
  //////        || lockValue == "32" || lockValue == "33" || lockValue == "34" || lockValue == "41")
  //////      { isPanic = true; }
  //////    } if (isPanic == true) {
  //////      v
  //////      ar Exit_Device_Options = door._FIND_ATTR_"Exit_Device_Options"_END_;
  //////      if (Exit_Device_Options != null)
  //////      {
  //////        var Exit_Device_Option_Value = Exit_Device_Options.$VALUE$;
  //////        if (Exit_Device_Option_Value == "EL") {
  //////          var EL_PowerSupply = door._FIND_ATTR_"EL_PowerSupply"_END_; if
  //////            (EL_PowerSupply != null) EL_PowerSupply.$SHOWDETAILS()$;
  //////        } else {
  //////          var EL_PowerSupply = door._FIND_ATTR_"EL_PowerSupply"_END_;
  //////          if (EL_PowerSupply != null) EL_PowerSupply.$HIDE()$;
  //////        }
  //////      }
  //////    } else {
  //////      var EL_PowerSupply = door._FIND_ATTR_"EL_PowerSupply"_END_;
  //////      if (EL_PowerSupply != null) EL_PowerSupply.$HIDE()$;
  //////    }
  //////  } return _MODEL_;
  //////  var messages = new List<string>();
  //////  for (int i = 0; i < _MODEL_.$DOORS$.Count; i++) {
  //////    var door = _MODEL_.$DOORS$[i]; var llOperatorRequired = false;
  //////    var lockAttribute = door._FIND_ATTR_"Lock"_END_; if (lockAttribute != null)
  //////    {
  //////      string lockValue = lockAttribute.$VALUE$;
  //////      if (lockValue == "06" || lockValue == "06T" || lockValue == "06B")
  //////      { llOperatorRequired = true; }
  //////    } if (llOperatorRequired) {
  //////      var llOperator = door._FIND_ATTR_"LL_Operator"_END_;
  //////      if (llOperator != null && llOperator.$VALUE$ == "SEL")
  //////      {
  //////        messages.Add(String.Format("Door {0}: Latch Lock Operator selection is required", i + 1));
  //////        messages.Add(String.Format("[Door{0}.LL_Operator]", i + 1));
  //////        messages.Add(String.Format("[Door{0}.Lock]", i + 1));
  //////      }
  //////    }
  //////  } return messages;
  //////  var messages = new List<string>();
  //////  for (int i = 0; i < _MODEL_.$DOORS$.Count; i++) {
  //////    var door = _MODEL_.$DOORS$[i]; var flushboltsRequired =
  //////      true; var lockAttribute = door._FIND_ATTR_"Lock"_END_;
  //////    if (lockAttribute != null) {
  //////      string lockValue = lockAttribute.$VALUE$;
  //////      if (lockValue == "00" || lockValue == "03" || lockValue == "14" ||
  //////        lockValue == "29" || lockValue == "31" || lockValue == "32" || lockValue == "9902" ||
  //////        lockValue == "9906" || lockValue == "99") { flushboltsRequired = false; }
  //////    } if (flushboltsRequired) {
  //////      var flushbolts = door._FIND_ATTR_"Flushbolts"_END_;
  //////      if (flushbolts != null && flushbolts.$VALUE$ == "00")
  //////      {
  //////        messages.Add("Flushbolts selection is required on these doors to secure the Inactive Leaf");
  //////        messages.Add(String.Format("[Door{0}.Flushbolts]", i + 1));
  //////        messages.Add(String.Format("[Door{0}.Lock]", i + 1));
  //////      }
  //////    }
  //////  } return messages;
  //////  var messages = new List<string>();
  //////  for (int i = 0; i < _MODEL_.$DOORS$.Count; i++) {
  //////    var door = _MODEL_.$DOORS$[i]; var llOperatorRequired = false;
  //////    var lockAttribute = door._FIND_ATTR_"Lock"_END_; if (lockAttribute != null)
  //////    {
  //////      string lockValue = lockAttribute.$VALUE$; if (lockValue == "06" || lockValue == "09")
  //////      { llOperatorRequired = true; }
  //////    } if (llOperatorRequired) {
  //////      var llOperator = door._FIND_ATTR_"LL_Operator"_END_;
  //////      if (llOperator != null && llOperator.$VALUE$ == "SEL")
  //////      {
  //////        messages.Add(String.Format("Door {0}: Latch Lock Operator selection is required", i + 1));
  //////        messages.Add(String.Format("[Door{0}.LL_Operator]", i + 1));
  //////        messages.Add(String.Format("[Door{0}.Lock]", i + 1));
  //////      }
  //////    }
  //////  } return messages;
  //////}
  lk() {

    ////Toggle Limit Stop for SFPO BP2
    //var DisplayAcHandlePerUnit = false;

    //var lockAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Locking"_END_;

    //if (lockAtt != null && lockAtt.$VALUE$ == "06") {
    //  DisplayAcHandlePerUnit = true;
    //}

    //var acHandlePerUnitAtt = _MODEL_.Frames[0]._FIND_ATTRC_"LimitStop"_END_;

    //if (DisplayAcHandlePerUnit == true) {
    //  acHandlePerUnitAtt.$HIDE()$;

    //}
    //else {
    //  acHandlePerUnitAtt.$SHOWDETAILS()$;
    //}


    //return _MODEL_;

    let DisplayAcHandlePerUnit = false;
    let lockAtt = this.model.findResourceFrameAttr("Locking");
    if (lockAtt != null && lockAtt.value == "06") {
      DisplayAcHandlePerUnit = true;
    }
    let acHandlePerUnitAtt = this.model.findResourceFrameAttr("LimitStop");
    if (DisplayAcHandlePerUnit == true) {
      acHandlePerUnitAtt.show = false;
    }
    else {
      acHandlePerUnitAtt.show = true;
    }
  }

  l1() {
    ///Display/Hide Omni-Drive Handle

    //var DisplayHandle = false;

    //var lockingAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Locking"_END_;

    //if (lockingAtt != null && (lockingAtt.$VALUE$ == "09")) {
    //  DisplayHandle = true;
    //}

    //var HandleAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Handle"_END_;

    //if (DisplayHandle == true) {
    //  HandleAtt.$SHOWDETAILS()$;
    //}
    //else {
    //  HandleAtt.$HIDE()$;
    //}


    let DisplayHandle = false;
    let lockingAtt = this.model.findResourceFrameAttr("Locking");
    if (lockingAtt && (lockingAtt.value == "09")) {
      DisplayHandle = true;
    }
    let HandleAtt = this.model.findResourceFrameAttr("Handle");
    if (DisplayHandle == true) {
      HandleAtt.show=true;
    }
    else {
      HandleAtt.show=false;
    }


    //return _MODEL_; 
  }

  l2() {

    ///GV - UT - PO Hide Lock on Shallow Depth
    //try {
    //  var framedepthAtt = _MODEL_.Frames[0]._FIND_ATTRC_"SystemDepth"_END_;
    //  var lockAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Locking"_END_;

    //  if (framedepthAtt != null && framedepthAtt.$VALUE$ == "SHALLOW") {
    //    lockAtt._FIND_VALUE_"09"_END_.$HIDE()$;
    //    lockAtt._FIND_VALUE_"01"_END_.$SHOWDETAILS()$;
    //    lockAtt._FIND_VALUE_"02"_END_.$SHOWDETAILS()$;
    //    lockAtt._FIND_VALUE_"03"_END_.$SHOWDETAILS()$;
    //    lockAtt._FIND_VALUE_"06"_END_.$SHOWDETAILS()$;
    //  }
    //  else {
    //    lockAtt._FIND_VALUE_"01"_END_.$SHOWDETAILS()$;
    //    lockAtt._FIND_VALUE_"02"_END_.$SHOWDETAILS()$;
    //    lockAtt._FIND_VALUE_"03"_END_.$SHOWDETAILS()$;
    //    lockAtt._FIND_VALUE_"06"_END_.$SHOWDETAILS()$;
    //    lockAtt._FIND_VALUE_"09"_END_.$SHOWDETAILS()$;
    //  }
    //}
    //catch (Exception ex)
    //{
    //  string debugFilePath = @"C:\temp\macro_buildpak.txt";
    //  System.IO.File.AppendAllText(debugFilePath, "*** Exception Logged at: " + DateTime.Now.ToString() + Environment.NewLine);
    //  System.IO.File.AppendAllText(debugFilePath, "Exception Message: " + ex.Message + Environment.NewLine);
    //}
    //return _MODEL_;

    try {
      let framedepthAtt = this.model.findResourceFrameAttr("SystemDepth");
      let lockAtt = this.model.findResourceFrameAttr("Locking");
      if (framedepthAtt && framedepthAtt.value == "SHALLOW") {
        //this.model.findAttrOption("TH108C", thresholdAttr).show
        this.model.findAttrOption("09",lockAtt).show=false;
        this.model.findAttrOption("01",lockAtt).show=true;
        this.model.findAttrOption("02",lockAtt).show=true;
        this.model.findAttrOption("03",lockAtt).show=true;
        this.model.findAttrOption("06",lockAtt).show=true;
      }
      else {
        this.model.findAttrOption("01",lockAtt).show=true;
        this.model.findAttrOption("02",lockAtt).show=true;
        this.model.findAttrOption("03",lockAtt).show=true;
        this.model.findAttrOption("06",lockAtt).show=true;
        this.model.findAttrOption("09",lockAtt).show=true;
      }
    }
    catch (ex)
    {
      
    }   

  }
  cg() {
    //Reorder Infill-- not done

    const lockingAtt = this.model.findNestedFrameAttr("Locking", 0);

    const infillAtt = this.model.findNestedFrameAttr("Infill", 0);
    let indexOfinfillAtt = -1;
    if (infillAtt) {
      indexOfinfillAtt = this.model.nestedFrames[0].attributeFilters.indexOf(infillAtt);
      if (indexOfinfillAtt > -1) {
        this.model.nestedFrames[0].attributeFilters.splice(indexOfinfillAtt, 1);
      }
    }
    if (infillAtt && lockingAtt) {
      let indexOflockingAtt = this.model.nestedFrames[0].attributeFilters.indexOf(lockingAtt);
      if (indexOfinfillAtt > -1) {
        this.model.nestedFrames[0].attributeFilters.splice(indexOflockingAtt, 0, infillAtt);
      } else {
        this.model.nestedFrames[0].attributeFilters.splice(0, 0, infillAtt);
      }
    }


    //////var lockingAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Locking"_END_;

    //////var infillAtt = _MODEL_.Frames[0]._FIND_ATTRC_"Infill"_END_;

    //////var indexOfinfillAtt = _MODEL_.Frames[0].Attributes.IndexOf(infillAtt);
    //////_MODEL_.Frames[0].Attributes.RemoveAt(indexOfinfillAtt);
    //////var indexOflockingAtt = _MODEL_.Frames[0].Attributes.IndexOf(lockingAtt);
    //////_MODEL_.Frames[0].Attributes.Insert(indexOflockingAtt, infillAtt);

    //////return _MODEL_;  
  }

  cj() {
  }
  cb() {

    ////Toggle Vent Type Limits for UTCO

    let DisplayAcHandlePerUnit = false;
    const lockAtt = this.model.findResourceFrameAttr("SystemDepth");
    const framesystemAtt = this.model.findResourceFrameAttr("SetInFrame");
    if (lockAtt) {
      if (lockAtt.value === "DEEP" && framesystemAtt.value === "FXF") { DisplayAcHandlePerUnit = true; }
    }
    const acHandlePerUnitAtt = this.model.findResourceFrameAttr("Vent Type Limits");
    if (acHandlePerUnitAtt) {
      if (DisplayAcHandlePerUnit) { acHandlePerUnitAtt.show = true; }
      else { acHandlePerUnitAtt.show = false; }
    }

  }
  cad1(model: any) {

    let Displayscreenmesh = false;
    const screenAtt = this.model.findResourceFrameAttr("Screens");
    if (screenAtt) {
      if (screenAtt.value === "True") {
        Displayscreenmesh = true;
      }
    }

    const screenmeshAtt = this.model.findResourceFrameAttr("ScreenMesh");
    if (screenmeshAtt) {

      if (Displayscreenmesh) {
        screenmeshAtt.show = true;
      } else {
        screenmeshAtt.show = true;
      }
    }




    //update it
    let thresholdAttr = this.model.findResourceFrameAttr("Threshold");
    let frameSystemAttr = this.model.findResourceFrameAttr("Frame System");
    let frameSystemAtt = '';
    if (!frameSystemAttr || !thresholdAttr) return;
    frameSystemAtt = frameSystemAttr.value;
    model.nestedFrames.forEach((el, index) => {
      var HandAtt = this.model.findNestedFrameAttr("Handing", index);
      if (!HandAtt) { return; }
      let HandVal = HandAtt.value;

      if (frameSystemAtt == "00" || frameSystemAtt == "01" || frameSystemAtt == "11" || frameSystemAtt == "12" ||
        frameSystemAtt == "13" || frameSystemAtt == "16F" || frameSystemAtt == "16" ||
        frameSystemAtt == "17" || frameSystemAtt == "WA01" ||
        frameSystemAtt == "WA02" || frameSystemAtt == "WA03" || frameSystemAtt == "WA04" ||
        frameSystemAtt == "WA05") {
        if (HandVal == "05" || HandVal == "06" || HandVal == "09") {
          model.findAttrOption("TH108C", thresholdAttr).show = false;
          model.findAttrOption("TH108CPO", thresholdAttr).show = false;;
          model.findAttrOption("TH109C", thresholdAttr).show = false;;
          model.findAttrOption("TH109CPO", thresholdAttr).show = false;;
          model.findAttrOption("KSTD", thresholdAttr).show = true;
          model.findAttrOption("TH00", thresholdAttr).show = true;
          model.findAttrOption("KSTDPO", thresholdAttr).show = true;
        }
        else {
          model.findAttrOption("KSTD", thresholdAttr).show = true;
          model.findAttrOption("TH00", thresholdAttr).show = true;
          model.findAttrOption("KSTDPO", thresholdAttr).show = true;
          model.findAttrOption("TH108C", thresholdAttr).show = true;
          model.findAttrOption("TH108CPO", thresholdAttr).show = true;
          model.findAttrOption("TH109C", thresholdAttr).show = true;
          model.findAttrOption("TH109CPO", thresholdAttr).show = true;
        }
      }
      else {
        model.findAttrOption("KSTD", thresholdAttr).show = true;
        model.findAttrOption("TH00", thresholdAttr).show = true;
        model.findAttrOption("KSTDPO", thresholdAttr).show = true;
      }
    });

  }

  c2(model) {
    //this.model.nestedFrames.forEach((el, index) => { let closerPrepRequired = false; let hingeValue = ""; let closerValue = ""; const hingeAttribute = this.model.findNestedFrameAttr("Hinge", index); if (hingeAttribute) { hingeValue = hingeAttribute.value; } const closerAttribute = this.model.findNestedFrameAttr("Closer", index); if (closerAttribute) { closerValue = closerAttribute.value; } if (hingeAttribute && closerAttribute) { if (hingeValue === "00") { if (closerValue === "20" || closerValue === "03" || closerValue === "04" || closerValue === "06") { closerPrepRequired = true; } } } if (closerPrepRequired === true) { const Spec_COC_Dop = this.model.findNestedFrameAttrByV6RefCode("Spec_COC_Dop", index); if (Spec_COC_Dop) { Spec_COC_Dop.show = true; } } else { var Spec_COC_Dop = this.model.findNestedFrameAttrByV6RefCode("Spec_COC_Dop", index); if (Spec_COC_Dop) { Spec_COC_Dop.show = false; } } });
    /*// Step 1 set up temporay variables for the attributes we want to display in the Configurations string
// these will be tested for their content, then translated into a generic/universal value
// for consistant output across seveveral different hardware types
// Load the varibales initially with their BuildPak attribute values, which come from BuildPak screen1

var frameSeries = _MODEL_.$FRAME$._FIND_ATTRP_"Frame System"_END_.$VALUE$;
var ExtFin = _MODEL_._FIND_ATTRP_"Exterior Finish"_END_.$VALUE$;
var TrnsmOption = _MODEL_.$FRAME$._FIND_ATTRP_"Transom"_END_.$VALUE$;
var doorSeries = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Door Type"_END_.$VALUE$;
var Hand = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Handing"_END_.$VALUE$;
var doorHinge = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Hinging"_END_.$VALUE$;
var drLck = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Locking"_END_.$VALUE$;
var xRails = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Cross Rails"_END_.$VALUE$;


//  Step 2 Load up some formating variables, and then declare the actual output varibles that will be loaded into
//  the configuration string.

var dashString = "-";
var FrmType = " ";
var DrType = " ";
var HandText = " ";
var HingeText = " ";
var LockText = " ";
var FinText = " ";
var XRailText = " ";
var OBTxt = " ";

// Step 3 Now test for the V6 attributes presence, meaning the focus has moved to BuildPak screen 2
// If any variable is not null, move its value into the first temporary variable for use during the
// testing which loads the output variables to the Configuration String

 var BP2frameSeries = _MODEL_.$FRAME$._FIND_ATTRC_"Frame Type"_END_;
 var BP2frmSeries = _MODEL_.$FRAME$._FIND_ATTRC_"FrmType"_END_;
 if (BP2frameSeries != null)
   {frameSeries = BP2frameSeries.$VALUE$;}
 if (BP2frmSeries != null)
   {frameSeries = BP2frmSeries.$VALUE$;}

 var OpenBack = _MODEL_.$FRAME$._FIND_ATTRC_"Tubular"_END_;
  if (OpenBack != null)
     if (OpenBack.$VALUE$ == "True")
        {OBTxt = "";}
      else
        {OBTxt = " O.B.";}

var BP2doorSeries = _MODEL_.$DOORS$[0]._FIND_ATTRC_"DrType"_END_;
if (BP2doorSeries != null)
    {doorSeries = BP2doorSeries.$VALUE$;}

var BP2Hand = _MODEL_.$DOORS$[0]._FIND_ATTRC_"Hand"_END_;
if  (BP2Hand != null)
    {Hand = BP2Hand.$VALUE$;}


var BP2doorHinge = _MODEL_.$DOORS$[0]._FIND_ATTRC_"Hinge"_END_;
if  (BP2doorHinge != null)
    {doorHinge = BP2doorHinge.$VALUE$;}


var BP2drLck = _MODEL_.$DOORS$[0]._FIND_ATTRC_"Lock"_END_;
if  (BP2drLck != null)
    {drLck = BP2drLck.$VALUE$;}

// Step 4 test the attribute values for their values and load the output text strings with generic names

 if (frameSeries == "01")
    {FrmType = "TF400";}
 else if (frameSeries == "11")
    {FrmType = "TFVG450";}
 else if (frameSeries == "12")
    {FrmType = "TFVG451";}
 else if (frameSeries == "13")
    {FrmType = "TFVG451T";}
 else if (frameSeries == "15")
    {FrmType = "TF 451T";}
 else if (frameSeries == "16F" | frameSeries == "16")
    {FrmType = "TF601";}
 else if (frameSeries == "20DG" | frameSeries == "20SG")
    {FrmType = "TL Std.";}
 else if (frameSeries == "21DG" | frameSeries == "21SG")
    {FrmType = "TL Heavy";}
 else if (frameSeries == "22DG" | frameSeries == "22SG")
    {FrmType = "TL Half Jmb.";}
 else if (frameSeries == "17" |frameSeries == "18")
    {FrmType = "TF601T";}
 else if (frameSeries == "05P" | frameSeries == "05PP")
    {FrmType = "EnCore 4-1/2\"";}
 else if (frameSeries == "06PP")
    {FrmType = "EnCore 6\"";}
 else if (frameSeries == "WA01" | frameSeries == "WA02" | frameSeries == "WA04")
    {FrmType = "3/4\" CW";}
 else if (frameSeries == "WA03" | frameSeries == "WA05")
    {FrmType = "7/8\" CW";}
 else if (frameSeries == "WA09")
    {FrmType = "29/32\" CW";}
 else
    {FrmType = "";}

var withString = " ";
if (frameSeries == "00")
    {
    FrmType = "Door Only - ";
    withString = "";
    }
else
    {FrmType = FrmType + OBTxt;}
    if (TrnsmOption == "Transom")
       {withString = " w/ TR with - ";}
        else if (TrnsmOption == "Non-Transom")
       {withString = " w/o TR with - ";}
    else
        {withString = "";}


 if (doorSeries == "01")
    {DrType = "190";}
 else if (doorSeries == "02")
    {DrType = "350";}
 else if (doorSeries == "03")
    {DrType = "500";}
 else if (doorSeries == "06")
    {DrType = "350TL";}
 else if (doorSeries == "07")
    {DrType = "500TL";}
 else if (doorSeries == "09")
    {DrType = "350HW";}
 else if (doorSeries == "10")
    {DrType = "500HW";}
 else if (doorSeries == "14")
    {DrType = "AA250";}
 else if (doorSeries == "15")
    {DrType = "AA425";}
 else if (doorSeries == "01BPES" | doorSeries == "01BPEP" | doorSeries == "09BPES" | doorSeries == "09BPEP")
    {DrType = "Frame Only";}
 else if (doorSeries == "14BPES" | doorSeries == "14BPEP" | doorSeries == "15BPES" | doorSeries == "15BPEP")
    {DrType = "Frame Only";}
 else
    {DrType = "";}

 if (Hand == "01")
    {HandText = "-LH";}
 else if (Hand == "03")
    {HandText = "-RH";}
 else if (Hand == "05")
    {HandText = "-H/R DA";}
 else if (Hand == "06")
    {HandText = "-H/L DA";}
 else if (Hand == "07")
    {HandText = "-S/A Pair";}
 else if (Hand == "09")
    {HandText = "-D/A Pair";}
 else
    {HandText = "";}

if (doorHinge == "01" | doorHinge == "10" | doorHinge == "11" | doorHinge == "12" | doorHinge == "15")
    {HingeText = "-O/P";}
 else if (doorHinge == "02" | doorHinge == "04" | doorHinge == "04C" | doorHinge == "16")
    {HingeText = "-B/H";}
 else if (doorHinge == "05")
    {HingeText = "-CGH";}
 else if (doorHinge == "06" | doorHinge == "07" | doorHinge == "08" | doorHinge == "14")
    {HingeText = "-C/H";}
 else if (doorHinge == "00" & (Hand == "05" | Hand == "06"| Hand == "09"))
    {HingeText = "-No Hinges, Radiused Stile";}
 else if (doorHinge == "00" | doorHinge == "00A" | doorHinge == "00B")
    {HingeText = "-No Hinges, Beveled Stile";}
 else if (doorHinge == "00C" | doorHinge == "86")
    {HingeText = "-No Hinges, Rabbeted Stile";}
 else if (doorHinge == "00R")
    {HingeText = "-No Hinges, Radiused Stile";}
 else
    {HingeText = "";}

    if (drLck == "15" | drLck == "20" | drLck == "20IR" | drLck == "30" | drLck == "33" | drLck == "34" | drLck == "36" | drLck == "37" | drLck == "38" | drLck == "38IR" | drLck == "42")
    {LockText = "-CR exit";}
 else if (drLck == "01" | drLck == "04" | drLck == "05" | drLck == "43")
    {LockText = "-DeadBolt";}
 else if (drLck == "16" | drLck == "21" | drLck == "26" | drLck == "28" | drLck == "31" | drLck == "39" | drLck == "40" | drLck == "44" | drLck == "45")
    {LockText = "-Rim exit";}
 else if (drLck == "06" | drLck == "09")
    {LockText = "-LLock";}
 else if (drLck == "01M")
    {LockText = "-2 DeadBolts";}
 else if (drLck == "02")
    {LockText = "-DeadBolt 2pt.";}
 else if (drLck == "03" | drLck == "03S" | drLck == "03IR")
    {LockText = "-DeadBolt 3pt.";}
 else if (drLck == "05IR")
    {LockText = "-DeadBolt 5pt.";}
 else if (drLck == "06T")
    {LockText = "-DeadBolt/LLock";}
 else if (drLck == "06B")
    {LockText = "-LLock/DeadBolt";}
 else if (drLck == "12")
    {LockText = "-Paneline";}
 else if (drLck == "24")
    {LockText = "-Dummy Paneline";}
 else if (drLck == "14" | drLck == "29")
    {LockText = "-Controller";}
 else if (drLck == "00")
    {LockText = "-No Lock";}
 else
    {LockText = "";}

if (ExtFin == "[COL:K:14 (14)]")
    {FinText = "-#14";}
 else if (ExtFin == "[COL:K:17 (17)]")
    {FinText = "-#17";}
 else if (ExtFin == "[COL:K:18 (18)]")
    {FinText = "-#18";}
 else if (ExtFin == "[COL:K:26 (26)]")
    {FinText = "-#26";}
 else if (ExtFin == "[COL:K:28 (28)]")
    {FinText = "-#28";}
 else if (ExtFin == "[COL:K:29 (29)]")
    {FinText = "-#29";}
 else if (ExtFin == "[COL:K:40 (40)]")
    {FinText = "-#40";}
 else if (ExtFin == null)
    {FinText = " ";}
 else
    {FinText = "-#22";}

if (xRails == "00" | xRails == null)
    {XRailText = "";}
else
    {XRailText = "-" + xRails;}

// Step 5 Output the finalized configurations string.

return FrmType + withString + DrType + HandText + HingeText + LockText + XRailText + FinText;
 */

    const index = 0;
    const FrameSystemAttr = this.model.findResourceFrameAttr("Frame System");
    let FrameSystemVal = FrameSystemAttr ? FrameSystemAttr.value : '';
    const ExteriorFinishAttr = this.model.findProductAttr("Exterior Finish");
    const ExteriorFinishVal = ExteriorFinishAttr ? ExteriorFinishAttr.value : '';
    const TransomAttr = this.model.findResourceFrameAttr("Transom");
    const TransomVal = TransomAttr ? TransomAttr.value : '';
    const DoorTypeAttr = this.model.findNestedFrameAttr("Door Type", index);
    let DoorTypeVal = DoorTypeAttr ? DoorTypeAttr.value : '';
    const HingingAttr = this.model.findNestedFrameAttr("Hinging", index);
    let HingingVal = HingingAttr ? HingingAttr.value : '';
    const HandingAttr = this.model.findNestedFrameAttr("Handing", index);
    let HandingVal = HandingAttr ? HandingAttr.value : '';
    const LockingAttr = this.model.findNestedFrameAttr("Locking", index);
    let LockingVal = LockingAttr ? LockingAttr.value : '';
    const CrossRailsAttr = this.model.findNestedFrameAttr("Cross Rails", index);
    const CrossRailsVal = CrossRailsAttr ? CrossRailsAttr.value : '';

    let dashString = "-";
    let FrmType = " ";
    let DrType = " ";
    let HandText = " ";
    let HingeText = " ";
    let LockText = " ";
    let FinText = " ";
    let XRailText = " ";
    let OBTxt = " ";

    // Step 3 Now test for the V6 attributes presence, meaning the focus has moved to BuildPak screen 2
    // If any variable is not null, move its value into the first temporary variable for use during the
    // testing which loads the output variables to the Configuration String

    var BP2frameSeries = this.model.findResourceFrameAttr("Frame Type");
    var BP2frmSeries = this.model.findResourceFrameAttr("FrmType");
    if (BP2frameSeries) { FrameSystemVal = BP2frameSeries.value; }
    if (BP2frmSeries) { FrameSystemVal = BP2frmSeries.value; }

    const OpenBackAttr = this.model.findResourceFrameAttr("Tubular");
    const OpenBackVal = OpenBackAttr ? OpenBackAttr.value : '';
    if (OpenBackAttr) {
      if (OpenBackVal === "True") { OBTxt = ""; }
      else { OBTxt = " O.B."; }
    }
    var BP2doorSeries = this.model.findNestedFrameAttr("DrType", index);
    if (BP2doorSeries) { DoorTypeVal = BP2doorSeries.value; }

    var BP2Hand = this.model.findNestedFrameAttr("Hand", index);
    if (BP2Hand) { HandingVal = BP2Hand.value; }


    var BP2doorHinge = this.model.findNestedFrameAttr("Hinge", index);
    if (BP2doorHinge) { HingingVal = BP2doorHinge.value; }


    var BP2drLck = this.model.findNestedFrameAttr("Lock", index);
    if (BP2drLck) { LockingVal = BP2drLck.value; }

    if (FrameSystemVal === "01") { FrmType = "TF400"; }
    else if (FrameSystemVal === "11") { FrmType = "TFVG450"; }
    else if (FrameSystemVal === "12") { FrmType = "TFVG451"; }
    else if (FrameSystemVal === "13") { FrmType = "TFVG451T"; }
    else if (FrameSystemVal === "15") { FrmType = "TF 451T"; }
    else if (FrameSystemVal === "16F" || FrameSystemVal === "16") { FrmType = "TF601"; }
    else if (FrameSystemVal === "20DG" || FrameSystemVal === "20SG") { FrmType = "TL Std."; }
    else if (FrameSystemVal === "21DG" || FrameSystemVal === "21SG") { FrmType = "TL Heavy"; }
    else if (FrameSystemVal === "22DG" || FrameSystemVal === "22SG") { FrmType = "TL Half Jmb."; }
    else if (FrameSystemVal === "17" || FrameSystemVal === "18") { FrmType = "TF601T"; }
    else if (FrameSystemVal === "05P" || FrameSystemVal === "05PP") { FrmType = "EnCore 4-1/2\""; }
    else if (FrameSystemVal === "06PP") { FrmType = "EnCore 6\""; }
    else if (FrameSystemVal === "WA01" || FrameSystemVal === "WA02" || FrameSystemVal === "WA04") { FrmType = "3/4\" CW"; }
    else if (FrameSystemVal === "WA03" || FrameSystemVal === "WA05") { FrmType = "7/8\" CW"; }
    else if (FrameSystemVal === "WA09") { FrmType = "29/32\" CW"; }
    else { FrmType = ""; }


    let withString = " ";
    if (FrameSystemVal == "00") {
      FrmType = "Door Only - ";
      withString = "";
    }
    else { FrmType = FrmType + OBTxt; }
    if (TransomVal === "Transom") { withString = " w/ TR with - "; }
    else if (TransomVal === "Non-Transom") { withString = " w/o TR with - "; }
    else { withString = ""; }


    if (DoorTypeVal === "01") { DrType = "190"; }
    else if (DoorTypeVal === "02") { DrType = "350"; }
    else if (DoorTypeVal === "03") { DrType = "500"; }
    else if (DoorTypeVal === "06") { DrType = "350TL"; }
    else if (DoorTypeVal === "07") { DrType = "500TL"; }
    else if (DoorTypeVal === "09") { DrType = "350HW"; }
    else if (DoorTypeVal === "10") { DrType = "500HW"; }
    else if (DoorTypeVal === "14") { DrType = "AA250"; }
    else if (DoorTypeVal === "15") { DrType = "AA425"; }
    else if (DoorTypeVal === "01BPES" || DoorTypeVal === "01BPEP" || DoorTypeVal === "09BPES" || DoorTypeVal === "09BPEP") { DrType = "Frame Only"; }
    else if (DoorTypeVal === "14BPES" || DoorTypeVal === "14BPEP" || DoorTypeVal == "15BPES" || DoorTypeVal === "15BPEP") { DrType = "Frame Only"; }
    else { DrType = ""; }

    if (HandingVal === "01") { HandText = "-LH"; }
    else if (HandingVal === "03") { HandText = "-RH"; }
    else if (HandingVal === "05") { HandText = "-H/R DA"; }
    else if (HandingVal === "06") { HandText = "-H/L DA"; }
    else if (HandingVal === "07") { HandText = "-S/A Pair"; }
    else if (HandingVal === "09") { HandText = "-D/A Pair"; }
    else { HandText = ""; }

    if (HingingVal === "01" || HingingVal === "10" || HingingVal === "11" || HingingVal === "12" || HingingVal === "15") { HingeText = "-O/P"; }
    else if (HingingVal === "02" || HingingVal === "04" || HingingVal === "04C" || HingingVal === "16") { HingeText = "-B/H"; }
    else if (HingingVal === "05") { HingeText = "-CGH"; }
    else if (HingingVal === "06" || HingingVal === "07" || HingingVal === "08" || HingingVal === "14") { HingeText = "-C/H"; }
    else if (HingingVal === "00" && (HandingVal === "05" || HandingVal === "06" || HandingVal === "09")) { HingeText = "-No Hinges, Radiused Stile"; }
    else if (HingingVal === "00" || HingingVal === "00A" || HingingVal === "00B") { HingeText = "-No Hinges, Beveled Stile"; }
    else if (HingingVal === "00C" || HingingVal === "86") { HingeText = "-No Hinges, Rabbeted Stile"; }
    else if (HingingVal === "00R") { HingeText = "-No Hinges, Radiused Stile"; }
    else { HingeText = ""; }


    if (LockingVal === "15" || LockingVal === "20" || LockingVal === "20IR" || LockingVal === "30" || LockingVal === "33" || LockingVal === "34" || LockingVal === "36" || LockingVal === "37" || LockingVal === "38" || LockingVal === "38IR" || LockingVal === "42") { LockText = "-CR exit"; }
    else if (LockingVal === "01" || LockingVal === "04" || LockingVal === "05" || LockingVal === "43") { LockText = "-DeadBolt"; }
    else if (LockingVal === "16" || LockingVal === "21" || LockingVal === "26" || LockingVal === "28" || LockingVal === "31" || LockingVal === "39" || LockingVal == "40" || LockingVal == "44" || LockingVal == "45") { LockText = "-Rim exit"; }
    else if (LockingVal === "06" || LockingVal === "09") { LockText = "-LLock"; }
    else if (LockingVal === "01M") { LockText = "-2 DeadBolts"; }
    else if (LockingVal === "02") { LockText = "-DeadBolt 2pt."; }
    else if (LockingVal === "03" || LockingVal === "03S" || LockingVal == "03IR") { LockText = "-DeadBolt 3pt."; }
    else if (LockingVal === "05IR") { LockText = "-DeadBolt 5pt."; }
    else if (LockingVal === "06T") { LockText = "-DeadBolt/LLock"; }
    else if (LockingVal === "06B") { LockText = "-LLock/DeadBolt"; }
    else if (LockingVal === "12") { LockText = "-Paneline"; }
    else if (LockingVal === "24") { LockText = "-Dummy Paneline"; }
    else if (LockingVal === "14" || LockingVal === "29") { LockText = "-Controller"; }
    else if (LockingVal === "00") { LockText = "-No Lock"; }
    else { LockText = ""; }


    if (ExteriorFinishVal === "[COL:K:14 (14)]") { FinText = "-#14"; }
    else if (ExteriorFinishVal === "[COL:K:17 (17)]") { FinText = "-#17"; }
    else if (ExteriorFinishVal === "[COL:K:18 (18)]") { FinText = "-#18"; }
    else if (ExteriorFinishVal === "[COL:K:26 (26)]") { FinText = "-#26"; }
    else if (ExteriorFinishVal === "[COL:K:28 (28)]") { FinText = "-#28"; }
    else if (ExteriorFinishVal === "[COL:K:29 (29)]") { FinText = "-#29"; }
    else if (ExteriorFinishVal === "[COL:K:40 (40)]") { FinText = "-#40"; }
    else if (ExteriorFinishVal === null) { FinText = " "; }
    else { FinText = "-#22"; }

    if (CrossRailsVal === "00" || CrossRailsVal) { XRailText = ""; }
    else { XRailText = "-" + CrossRailsVal; }

    // Step 5 Output the finalized configurations string.
    console.log(FrmType + withString + DrType + HandText + HingeText + LockText + XRailText + FinText);
    this.model.computedName = FrmType + withString + DrType + HandText + HingeText + LockText + XRailText + FinText;
  }


  //IR_DR 1DO configuration description

  //  // Step 1 set up temporay variables for the attributes we want to display in the Configurations string
  //// these will be tested for their content, then translated into a generic/universal value
  //// for consistant output across seveveral different hardware types
  //// Load the varibales initially with their BuildPak attribute values, which come from BuildPak screen1

  //var frameSeries = _MODEL_.$FRAME$._FIND_ATTRP_"Frame System"_END_.$VALUE$;
  //var ExtFin = _MODEL_._FIND_ATTRP_"Exterior Finish"_END_.$VALUE$;
  //var TrnsmOption = _MODEL_.$FRAME$._FIND_ATTRP_"Transom"_END_.$VALUE$;
  //var doorSeries = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Door Type"_END_.$VALUE$;
  //var Hand = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Handing"_END_.$VALUE$;
  //var doorHinge = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Hinging"_END_.$VALUE$;
  //var drLck = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Locking"_END_.$VALUE$;
  //var xRails = _MODEL_.$DOORS$[0]._FIND_ATTRP_"Cross Rails"_END_.$VALUE$;

  ////  Step 2 Load up some formating variables, and then declare the actual output varibles that will be loaded into
  ////  the configuration string.

  //var dashString = "-";
  //var FrmType = " ";
  //var DrType = " ";
  //var HandText = " ";
  //var HingeText = " ";
  //var LockText = " ";
  //var FinText = " ";
  //var XRailText = " ";

  //// Step 3 Now test for the V6 attributes presence, meaning the focus has moved to BuildPak screen 2
  //// If any variable is not null, move its value into the first temporary variable for use during the
  //// testing which loads the output variables to the Configuration String

  //var BP2frameSeries = _MODEL_.$FRAME$._FIND_ATTRC_"Frame Type"_END_;
  //if (BP2frameSeries != null) { frameSeries = BP2frameSeries.$VALUE$; }

  //var BP2doorSeries = _MODEL_.$DOORS$[0]._FIND_ATTRC_"DrType"_END_;
  //if (BP2doorSeries != null) { doorSeries = BP2doorSeries.$VALUE$; }

  //var BP2Hand = _MODEL_.$DOORS$[0]._FIND_ATTRC_"Hand"_END_;
  //if (BP2Hand != null) { Hand = BP2Hand.$VALUE$; }


  //var BP2doorHinge = _MODEL_.$DOORS$[0]._FIND_ATTRC_"Hinge"_END_;
  //if (BP2doorHinge != null) { doorHinge = BP2doorHinge.$VALUE$; }


  //var BP2drLck = _MODEL_.$DOORS$[0]._FIND_ATTRC_"Lock"_END_;
  //if (BP2drLck != null) { drLck = BP2drLck.$VALUE$; }


  //// Step 4 test the attribute values for their values and load the output text strings with generic names

  //if (frameSeries == "IR500") { FrmType = "IR 500"; }
  //else if (frameSeries == "IR501") { FrmType = "IR 501"; }
  //else if (frameSeries == "IR501T") { FrmType = "IR 501T"; }
  //else if (frameSeries == "IR501UT") { FrmType = "IR 501UT"; }
  //else if (frameSeries == "IR450") { FrmType = "TF450"; }
  //else if (frameSeries == "IR451") { FrmType = "TF451"; }
  //else if (frameSeries == "IR451T") { FrmType = "TF451T"; }
  //else if (frameSeries == "16F" | frameSeries == "16") { FrmType = "TF601"; }
  //else if (frameSeries == "17") { FrmType = "TF601T"; }
  //else if (frameSeries == "IR1600") { FrmType = "7/8\" CW"; }
  //else { FrmType = ""; }

  //var withString = " ";
  //if (frameSeries == "00") {
  //  FrmType = "Door Only - ";
  //  withString = "";
  //}
  //else
  //  if (TrnsmOption == "Transom") { withString = " w/ TR with - "; }
  //  else if (TrnsmOption == "Non-Transom") { withString = " w/o TR with - "; }
  //  else { withString = ""; }


  //if (doorSeries == "02") { DrType = "350IR"; }
  //else if (doorSeries == "03") { DrType = "500IR"; }
  //else if (doorSeries == "09") { DrType = "350HWIR"; }
  //else if (doorSeries == "10") { DrType = "500HWIR"; }
  //else if (doorSeries == "01BPES" | doorSeries == "01BPEP" | doorSeries == "09BPES" | doorSeries == "09BPEP") { DrType = "Frame Only"; }
  //else { DrType = ""; }

  //if (Hand == "01") { HandText = "-LH"; }
  //else if (Hand == "03") { HandText = "-RH"; }
  //else if (Hand == "05") { HandText = "-H/R DA"; }
  //else if (Hand == "06") { HandText = "-H/L DA"; }
  //else if (Hand == "07") { HandText = "-S/A Pair"; }
  //else if (Hand == "09") { HandText = "-D/A Pair"; }
  //else { HandText = ""; }

  //if (doorHinge == "01" | doorHinge == "10" | doorHinge == "11" | doorHinge == "12" | doorHinge == "15") { HingeText = "-O/P"; }
  //else if (doorHinge == "02" | doorHinge == "04" | doorHinge == "04C" | doorHinge == "16") { HingeText = "-B/H"; }
  //else if (doorHinge == "05") { HingeText = "-CGH"; }
  //else if (doorHinge == "06" | doorHinge == "07" | doorHinge == "08" | doorHinge == "14") { HingeText = "-C/H"; }
  //else if (doorHinge == "00" & (Hand == "05" | Hand == "06" | Hand == "09")) { HingeText = "-No Hinges, Radiused Stile"; }
  //else if (doorHinge == "00" | doorHinge == "00A" | doorHinge == "00B") { HingeText = "-No Hinges, Beveled Stile"; }
  //else if (doorHinge == "00C" | doorHinge == "86") { HingeText = "-No Hinges, Rabbeted Stile"; }
  //else if (doorHinge == "00R") { HingeText = "-No Hinges, Radiused Stile"; }
  //else { HingeText = ""; }

  //if (drLck == "15" | drLck == "20" | drLck == "20IR" | drLck == "30" | drLck == "33" | drLck == "34" | drLck == "36" | drLck == "37" | drLck == "38" | drLck == "38IR" | drLck == "42") { LockText = "-CR exit"; }
  //else if (drLck == "01" | drLck == "04" | drLck == "05" | drLck == "43") { LockText = "-DeadBolt"; }
  //else if (drLck == "16" | drLck == "21" | drLck == "26" | drLck == "28" | drLck == "31" | drLck == "39" | drLck == "40" | drLck == "44" | drLck == "45") { LockText = "-Rim exit"; }
  //else if (drLck == "06" | drLck == "09") { LockText = "-LLock"; }
  //else if (drLck == "01M") { LockText = "-2 DeadBolts"; }
  //else if (drLck == "02") { LockText = "-DeadBolt 2pt."; }
  //else if (drLck == "03" | drLck == "03S" | drLck == "03IR") { LockText = "-DeadBolt 3pt."; }
  //else if (drLck == "05IR") { LockText = "-DeadBolt 5pt."; }
  //else if (drLck == "06T") { LockText = "-DeadBolt/LLock"; }
  //else if (drLck == "06B") { LockText = "-LLock/DeadBolt"; }
  //else if (drLck == "12") { LockText = "-Paneline"; }
  //else if (drLck == "24") { LockText = "-Dummy Paneline"; }
  //else if (drLck == "14" | drLck == "29") { LockText = "-Controller"; }
  //else if (drLck == "00") { LockText = "-No Lock"; }
  //else { LockText = ""; }

  //if (ExtFin == "[COL:K:14 (14)]") { FinText = "-#14"; }
  //else if (ExtFin == "[COL:K:17 (17)]") { FinText = "-#17"; }
  //else if (ExtFin == "[COL:K:18 (18)]") { FinText = "-#18"; }
  //else if (ExtFin == "[COL:K:26 (26)]") { FinText = "-#26"; }
  //else if (ExtFin == "[COL:K:28 (28)]") { FinText = "-#28"; }
  //else if (ExtFin == "[COL:K:29 (29)]") { FinText = "-#29"; }
  //else if (ExtFin == "[COL:K:40 (40)]") { FinText = "-#40"; }
  //else if (ExtFin == null) { FinText = " "; }
  //else { FinText = "-#22"; }

  //if (xRails == "00" | xRails == null) { XRailText = ""; }
  //else { XRailText = "-" + xRails; }

  //// Step 5 Output the finalized configurations string.

  //return FrmType + withString + DrType + HandText + HingeText + LockText + XRailText + FinText;

  c4(model: any) {//issue 661
    const FrameSystemAttr = this.model.findResourceFrameAttr("Frame System");
    let frameSeries = FrameSystemAttr ? FrameSystemAttr.value : '';
    const TransomAttr = this.model.findResourceFrameAttr("Transom");
    const TrnsmOption = TransomAttr ? TransomAttr.value : '';
    if (TransomAttr) {
      let ntr = TransomAttr.options.find(x => x.value === 'Non-Transom');
      let tr = TransomAttr.options.find(x => x.value === 'Transom');
      if (frameSeries === "IR501T" || frameSeries === "IR501UT") {
        ntr.show = false;
        TransomAttr.value = 'Transom';
      }
      else {
        tr.show = true;
        ntr.show = true;
      }
    }
  }

  c3(model: any) {

    const index = 0;
    const FrameSystemAttr = this.model.findResourceFrameAttr("Frame System");
    let frameSeries = FrameSystemAttr ? FrameSystemAttr.value : '';
    const ExteriorFinishAttr = this.model.findProductAttr("Exterior Finish");
    const ExtFin = ExteriorFinishAttr ? ExteriorFinishAttr.value : '';
    const TransomAttr = this.model.findResourceFrameAttr("Transom");
    const TrnsmOption = TransomAttr ? TransomAttr.value : '';
    const DoorTypeAttr = this.model.findNestedFrameAttr("Door Type", index);
    let doorSeries = DoorTypeAttr ? DoorTypeAttr.value : '';
    const HandingAttr = this.model.findNestedFrameAttr("Handing", index);
    let Hand = HandingAttr ? HandingAttr.value : '';
    const HingingAttr = this.model.findNestedFrameAttr("Hinging", index);
    let doorHinge = HingingAttr ? HingingAttr.value : '';
    const LockingAttr = this.model.findNestedFrameAttr("Locking", index);
    let drLck = LockingAttr ? LockingAttr.value : '';
    const CrossRailsAttr = this.model.findNestedFrameAttr("Cross Rails", index);
    const xRails = CrossRailsAttr ? CrossRailsAttr.value : '';

    //  Step 2 Load up some formating variables, and then declare the actual output varibles that will be loaded into
    //  the configuration string.

    let dashString = "-";
    let FrmType = " ";
    let DrType = " ";
    let HandText = " ";
    let HingeText = " ";
    let LockText = " ";
    let FinText = " ";
    let XRailText = " ";

    // Step 3 Now test for the V6 attributes presence, meaning the focus has moved to BuildPak screen 2
    // If any variable is not null, move its value into the first temporary variable for use during the
    // testing which loads the output variables to the Configuration String


    const BP2frameSeries = this.model.findResourceFrameAttr("Frame System");
    if (BP2frameSeries) { frameSeries = BP2frameSeries.value }

    const BP2doorSeries = this.model.findResourceFrameAttr("DrType");
    if (BP2doorSeries) { doorSeries = BP2doorSeries.value; }

    const BP2Hand = this.model.findResourceFrameAttr("Hand");
    if (BP2Hand) { Hand = BP2Hand.value; }


    const BP2doorHinge = this.model.findResourceFrameAttr("Hinge");
    if (BP2doorHinge) { doorHinge = BP2doorHinge.value; }


    const BP2drLck = this.model.findResourceFrameAttr("Lock");
    if (BP2drLck) { drLck = BP2drLck.value; }


    // Step 4 test the attribute values for their values and load the output text strings with generic names


    if (frameSeries === "IR500") { FrmType = "IR 500"; }
    else if (frameSeries === "IR501") { FrmType = "IR 501"; }
    else if (frameSeries === "IR501T") { FrmType = "IR 501T"; }
    else if (frameSeries === "IR501UT") { FrmType = "IR 501UT"; }
    else if (frameSeries === "IR450") { FrmType = "TF450"; }
    else if (frameSeries === "IR451") { FrmType = "TF451"; }
    else if (frameSeries === "IR451T") { FrmType = "TF451T"; }
    else if (frameSeries === "16F" || frameSeries === "16") { FrmType = "TF601"; }
    else if (frameSeries === "17") { FrmType = "TF601T"; }
    else if (frameSeries === "IR1600") { FrmType = "7/8\" CW"; }
    else { FrmType = ""; }

    let withString = " ";
    if (frameSeries === "00") {
      FrmType = "Door Only - ";
      withString = "";
    } else
      if (TrnsmOption === "Transom") { withString = " w/ TR with - "; }
      else if (TrnsmOption === "Non-Transom") { withString = " w/o TR with - "; }
      else { withString = ""; }

    if (doorSeries === "02") { DrType = "350IR"; }
    else if (doorSeries === "03") { DrType = "500IR"; }
    else if (doorSeries === "09") { DrType = "350HWIR"; }
    else if (doorSeries === "10") { DrType = "500HWIR"; }
    else if (doorSeries === "01BPES" || doorSeries === "01BPEP" || doorSeries === "09BPES" || doorSeries === "09BPEP") { DrType = "Frame Only"; }
    else { DrType = ""; }

    if (Hand === "01") { HandText = "-LH"; }
    else if (Hand === "03") { HandText = "-RH"; }
    else if (Hand === "05") { HandText = "-H/R DA"; }
    else if (Hand === "06") { HandText = "-H/L DA"; }
    else if (Hand === "07") { HandText = "-S/A Pair"; }
    else if (Hand === "09") { HandText = "-D/A Pair"; }
    else { HandText = ""; }


    if (doorHinge === "01" || doorHinge === "10" || doorHinge === "11" || doorHinge === "12" || doorHinge === "15") { HingeText = "-O/P"; }
    else if (doorHinge === "02" || doorHinge === "04" || doorHinge === "04C" || doorHinge === "16") { HingeText = "-B/H"; }
    else if (doorHinge === "05") { HingeText = "-CGH"; }
    else if (doorHinge === "06" || doorHinge === "07" || doorHinge === "08" || doorHinge === "14") { HingeText = "-C/H"; }
    else if (doorHinge === "00" && (Hand === "05" || Hand === "06" || Hand === "09")) { HingeText = "-No Hinges, Radiused Stile"; }
    else if (doorHinge === "00" || doorHinge === "00A" || doorHinge === "00B") { HingeText = "-No Hinges, Beveled Stile"; }
    else if (doorHinge === "00C" || doorHinge === "86") { HingeText = "-No Hinges, Rabbeted Stile"; }
    else if (doorHinge == "00R") { HingeText = "-No Hinges, Radiused Stile"; }
    else { HingeText = ""; }


    if (drLck === "15" || drLck === "20" || drLck === "20IR" || drLck === "30" || drLck === "33" || drLck === "34" || drLck === "36" || drLck === "37" || drLck === "38" || drLck === "38IR" || drLck === "42") { LockText = "-CR exit"; }
    else if (drLck === "01" || drLck === "04" || drLck === "05" || drLck === "43") { LockText = "-DeadBolt"; }
    else if (drLck === "16" || drLck === "21" || drLck === "26" || drLck === "28" || drLck === "31" || drLck === "39" || drLck === "40" || drLck === "44" || drLck === "45") { LockText = "-Rim exit"; }
    else if (drLck === "06" || drLck === "09") { LockText = "-LLock"; }
    else if (drLck === "01M") { LockText = "-2 DeadBolts"; }
    else if (drLck === "02") { LockText = "-DeadBolt 2pt."; }
    else if (drLck === "03" || drLck == "03S" || drLck == "03IR") { LockText = "-DeadBolt 3pt."; }
    else if (drLck === "05IR") { LockText = "-DeadBolt 5pt."; }
    else if (drLck === "06T") { LockText = "-DeadBolt/LLock"; }
    else if (drLck === "06B") { LockText = "-LLock/DeadBolt"; }
    else if (drLck === "12") { LockText = "-Paneline"; }
    else if (drLck === "24") { LockText = "-Dummy Paneline"; }
    else if (drLck === "14" || drLck == "29") { LockText = "-Controller"; }
    else if (drLck === "00") { LockText = "-No Lock"; }
    else { LockText = ""; }

    if (ExtFin === "[COL:K:14 (14)]") { FinText = "-#14"; }
    else if (ExtFin === "[COL:K:17 (17)]") { FinText = "-#17"; }
    else if (ExtFin === "[COL:K:18 (18)]") { FinText = "-#18"; }
    else if (ExtFin === "[COL:K:26 (26)]") { FinText = "-#26"; }
    else if (ExtFin === "[COL:K:28 (28)]") { FinText = "-#28"; }
    else if (ExtFin === "[COL:K:29 (29)]") { FinText = "-#29"; }
    else if (ExtFin === "[COL:K:40 (40)]") { FinText = "-#40"; }
    else if (ExtFin === null) { FinText = " "; }
    else { FinText = "-#22"; }

    if (xRails === "00" || xRails === null) { XRailText = ""; }
    else { XRailText = "-" + xRails; }

    // Step 5 Output the finalized configurations string.

    this.model.computedName = FrmType + withString + DrType + HandText + HingeText + LockText + XRailText + FinText;
    console.log(this.model.computedName);

  }
  c65(model: any) {
    //////foreach(var door in _MODEL_.$DOORS$) {
    //////  var HandVal = door._FIND_ATTRP_"Handing"_END_.$VALUE$;
    //////  var DoorType = door._FIND_ATTRP_"Door Type"_END_.$VALUE$;
    //////  var Lock = door._FIND_ATTR_"IR_DR Locking"_END_;

    //////  if (HandVal == "01" | HandVal == "03") {
    //////    //Lock._FIND_VALUE_"01IR"_END_.$HIDE()$;
    //////    Lock._FIND_VALUE_"05IR"_END_.$HIDE()$;
    //////  }
    //////  else {
    //////    //Lock._FIND_VALUE_"01IR"_END_.$SHOW()$;
    //////    Lock._FIND_VALUE_"05IR"_END_.$SHOW()$;
    //////  }

    //////  if (DoorType == "02") {
    //////    Lock._FIND_VALUE_"44"_END_.$HIDE()$;
    //////    Lock._FIND_VALUE_"45"_END_.$HIDE()$;
    //////  }
    //////  else {
    //////    Lock._FIND_VALUE_"44"_END_.$SHOW()$;
    //////    Lock._FIND_VALUE_"45"_END_.$SHOW()$;
    //////  }
    //////}
    //////return _MODEL_;

    this.model.nestedFrames.forEach((nf, index) => {
      const HandAttr = this.model.findNestedFrameAttr("Handing", index);
      const DoorTypeAttr = this.model.findNestedFrameAttr("Door Type", index);
      const LockAttr = this.model.findNestedFrameAttr("IR_DR Locking", index);
      if (HandAttr && DoorTypeAttr && LockAttr) {
        const HandVal = HandAttr.value;
        const DoorType = DoorTypeAttr.value;
        const Lock = LockAttr.value;

        if (HandVal === "01" || HandVal === "03") {
          this.model.findAttrOption("05IR", LockAttr).show = false;
        }
        else {
          this.model.findAttrOption("05IR", LockAttr).show = true;
        }

        if (DoorType === "02") {
          this.model.findAttrOption("44", LockAttr).show = false;
          this.model.findAttrOption("45", LockAttr).show = false;
        }
        else {
          this.model.findAttrOption("44", LockAttr).show = true;
          this.model.findAttrOption("45", LockAttr).show = true;
        }
      }
    })
  }
  stringFunc(productsstring: string, keywordstring: string): boolean {
    //productsstring//'STD_DR*DO,STD_DR*CRIP*,HW_DR*,TL_DR*,IR_*,TSD_DR*,190-*,350-*,400-*,450-*,451-*,500-*,540-*,550-*,551-*'
    //keyword//TL_DR*
    const productsArray: string[] = productsstring.split(",");
    const keywordArray: string[] = keywordstring.split("*");

    if (productsArray && keywordArray) {
      if (keywordArray.length === 2) {

        productsArray.forEach((product, i, arr) => {
          //product//STD_DR3DO
          if (product && keywordArray[0] && keywordArray[1]) {
            if (product.toUpperCase().startsWith(keywordArray[0].toUpperCase()) && product.toUpperCase().endsWith(keywordArray[1].toUpperCase())) {
              return true;
            } else {
              return false;
            }
          }


        });

      } else if (keywordArray.length > 2) {

      }
    }
    return false;
  }

}




